import Swiper from 'swiper'

export const blogSection = () => {
  const breakpoint = window.matchMedia('(min-width:31.25rem)')
  const blogSection = document.querySelectorAll('.swiper-blog')
  let mySwiper

  const breakpointChecker = () => {
    if (breakpoint.matches === true) {
      if (mySwiper !== undefined) {
        mySwiper.forEach((slider) => {
          slider.destroy(true, true)
        })
      } else {
        return
      }
    } else if (breakpoint.matches === false && blogSection.length > 0) {
      return enableSwiper()
    }
  }

  const enableSwiper = () => {
    mySwiper = new Swiper('.swiper-blog', {
      slidesPerView: 1.2,
      spaceBetween: 22,
      centeredSlides: true,
    })
  }

  window.addEventListener('load', () => {
    breakpoint.addListener(breakpointChecker)

    breakpointChecker()
  })
}
